import { takeLatest, call, put } from 'redux-saga/effects'

import {
  GET_MEDICAL_NEIGHBORHOOD_REQUEST,
  GET_MEDICAL_NEIGHBORHOOD_SUCCESS,
  GET_MEDICAL_NEIGHBORHOOD_FAILURE,
  GET_NEIGHBORHOOD_PROVIDER_DETAILS_REQUEST,
  GET_NEIGHBORHOOD_PROVIDER_DETAILS_SUCCESS,
  GET_NEIGHBORHOOD_PROVIDER_DETAILS_FAILURE,
} from '../constants'
import { api } from '../services'

function* getMedicalNeighborhoodWalker(action) {
  try {
    const result = yield call(api.getMedicalNeighborhood, action.payload)
    yield put({
      type: GET_MEDICAL_NEIGHBORHOOD_SUCCESS,
      payload: result.data,
    })
  } catch (e) {
    yield put({ type: GET_MEDICAL_NEIGHBORHOOD_FAILURE })
  }
}

export function* getMedicalNeighborhoodWatcherSaga() {
  yield takeLatest(
    GET_MEDICAL_NEIGHBORHOOD_REQUEST,
    getMedicalNeighborhoodWalker
  )
}

function* getNeighborhoodProviderWalker(action) {
  try {
    const result = yield call(api.getProviderDetailsRequest, action.payload)
    yield put({
      type: GET_NEIGHBORHOOD_PROVIDER_DETAILS_SUCCESS,
      payload: result.data,
    })
  } catch (e) {
    yield put({ type: GET_NEIGHBORHOOD_PROVIDER_DETAILS_FAILURE, payload: e })
  }
}

export function* getNeighborhoodProviderWatcherSaga() {
  yield takeLatest(
    GET_NEIGHBORHOOD_PROVIDER_DETAILS_REQUEST,
    getNeighborhoodProviderWalker
  )
}
